import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Recommendation from '../Recommendation/Recommendation';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';

const ResultsItem = ({ index, resultGroup, startExpanded, createRank }) => {
  const { reason, recs } = resultGroup;
  const locId = useContext(LocaleContext);

  return (
    <div className="rec-group">
      <div className="group-container">
        <div className="reason">
          <h3>
            {`${reason}${getText(
              locId,
              'Results',
              'reasonEnding',
              'ResultsItem'
            )}`}
          </h3>
        </div>
        <div className="rec-container">
          {recs.map((rec, i) => (
            <Recommendation
              startExpanded={startExpanded}
              key={rec.title}
              rec={rec}
              index={`${index}-${i}`}
              createRank={createRank}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

ResultsItem.defaultProps = {
  startExpanded: false,
};

ResultsItem.propTypes = {
  resultGroup: PropTypes.shape({
    reason: PropTypes.string.isRequired,
    recs: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  startExpanded: PropTypes.bool,
  index: PropTypes.string.isRequired,
  createRank: PropTypes.func.isRequired,
};

export default ResultsItem;
